
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { BooleanCriterionContent } from '@/jbi-shared/types/criterions.types';
import { isTruthy } from '@/jbi-shared/util/watcher.vue-decorator';

@Component({
  components: { ValidationProvider, ValidationObserver },
  data() {
    const opts = (this as Vue & { options?: [string, string] }).options ?? [];
    return {
      truthy: opts[0] ?? 'True',
      falsy: opts[1] ?? 'False'
    };
  }
})
export default class BooleanCriterionInput extends Vue {
  @Prop()
  public options!: BooleanCriterionContent['booleanOptions'];

  declare truthy: string;
  declare falsy: string;

  @Watch('truthy')
  @Watch('falsy')
  public onChanged() {
    this.$emit('update:options', [this.truthy, this.falsy]);
  }

  @isTruthy
  @Watch('options')
  public onRangeUpdated() {
    this.truthy = this.options[0];
    this.falsy = this.options[1];
  }
}
